import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useNotifications } from '@wallyhealth/web-core'
import { unsubscribe } from './api'

export const useUnsubscribe = () => {
  const [isUnsubscribing, setIsUnsubscribing] = useState(false)

  const navigate = useNavigate()
  const notifications = useNotifications()

  const tryUnsubscribe = async ({ token, campaignId }) => {
    try {
      setIsUnsubscribing(true)

      await unsubscribe({ token, campaignId })

      navigate('/unsubscribe/success')
    } catch (err) {
      setIsUnsubscribing(false)
      notifications.error(err.message || 'Oops, something went wrong. Please try again.')
    }
  }

  return {
    isUnsubscribing,
    unsubscribe: tryUnsubscribe
  }
}
